/**
 * Magma Dice Factory
 *
 * Creates color-specific magma dice components using a factory pattern.
 * All 4 color variants (Red, Blue, Yellow, Green) are generated from
 * MagmaDiceComponent with per-color schemes.
 */

import React from 'react';
import type { DiceProps } from '../basics/constants/types';
import MagmaDiceComponent from './MagmaDiceComponent';
import { MAGMA_DICE_COLOR_SCHEMES, type MagmaDiceColorScheme } from './constants/diceColorSchemes';

type DiceColor = 'red' | 'blue' | 'yellow' | 'green';

function createMagmaDice(color: DiceColor) {
  const colorScheme: MagmaDiceColorScheme = MAGMA_DICE_COLOR_SCHEMES[color];
  const displayName = `Magma${color.charAt(0).toUpperCase() + color.slice(1)}Dice`;

  const ColoredDice = React.memo(function ColoredDice(props: DiceProps) {
    return <MagmaDiceComponent {...props} colorScheme={colorScheme} />;
  });

  ColoredDice.displayName = displayName;
  return ColoredDice;
}

export const RedDice = createMagmaDice('red');
export const BlueDice = createMagmaDice('blue');
export const YellowDice = createMagmaDice('yellow');
export const GreenDice = createMagmaDice('green');
